module.exports = __webpack_public_path__ + "static/img/wechat-drcom.43f0999a.svg";